import styles from "./Error.module.scss";

const screens = [
  "https://screendesigns-dev.s3.amazonaws.com/avs-pp/472696283ba446a4a1f484547f84f15d.jpg",
  "https://screendesigns-dev.s3.amazonaws.com/avs-pp/935f6c6de981401fb938b90fd40f4961.jpg",
  "https://screendesigns-dev.s3.amazonaws.com/avs-pp/135f2a415d2f4e39b0f905690886a992.jpg",
];

const Error = () => {
  const handleExploreClick = () => {
    // Navigate to home or apps page
    window.location.href = "/";
  };

  return (
    <div className={styles.root}>
      <h1 className={styles.title}>Lost in the Ocean of Inspiration</h1>

      <p className={styles.subtitle}>
        We couldn't find this page. But why not explore some of the top app
        flows instead?
      </p>

      <button className={styles.exploreButton} onClick={handleExploreClick}>
        Explore Top Apps
      </button>

      <div className={styles.mockupsContainer}>
        {screens.map((screen, index) => (
          <img
            key={index}
            src={screen}
            alt="Mockup"
            className={styles.mockup}
          />
        ))}
      </div>

      <p className={styles.footerMessage}>
        Even the best apps sometimes hit a 404.
      </p>
    </div>
  );
};

export default Error;
